import { motion } from "framer-motion";
import galleryImg1 from "../../assets/images/gallery/work/galleryImg1.jpeg";
import galleryImg2 from "../../assets/images/gallery/work/galleryImg2.jpeg";
import galleryImg3 from "../../assets/images/gallery/work/galleryImg3.JPG";
import galleryImg4 from "../../assets/images/gallery/work/galleryImg4.JPG";
import galleryImg5 from "../../assets/images/gallery/work/galleryImg5.JPG";
import galleryImg6 from "../../assets/images/gallery/work/galleryImg6.JPG";
import galleryImg7 from "../../assets/images/gallery/work/galleryImg7.JPG";
import galleryImg8 from "../../assets/images/gallery/work/galleryImg8.JPG";
import heroImage from "../../assets/images/hero-image-12.jpg";

/* ================= DATA ================= */
const projects = [
  {
    slug: "heli-access",
    title: "Into the Range",
    subtitle: "Expedition Access & Arrival",
    image: galleryImg1,
  },
  {
    slug: "field-ops",
    title: "Command Tent",
    subtitle: "Decisions at Altitude",
    image: galleryImg2,
  },
  {
    slug: "basecamp",
    title: "Above the Clouds",
    subtitle: "Life at Base Camp",
    image: galleryImg3,
  },
  {
    slug: "ascent",
    title: "The Ascent",
    subtitle: "Fixed Lines & Forward Motion",
    image: galleryImg4,
  },
  {
    slug: "glacier",
    title: "Crossing Ice",
    subtitle: "Glacier Travel & Trust",
    image: galleryImg5,
  },
  {
    slug: "ridge",
    title: "High Exposure",
    subtitle: "Ridges, Ropes, Resolve",
    image: galleryImg6,
  },
  {
    slug: "summit",
    title: "Above the Skies",
    subtitle: "Moments at the Top",
    image: galleryImg7,
  },
  {
    slug: "summit-push",
    title: "On the Knife Edge",
    subtitle: "Where Every Step Is Earned",
    image: galleryImg8,
  }
];

/* ================= ANIMATION VARIANTS ================= */
const cardVariants = {
  rest: { y: 0 },
  hover: { y: -4 },
};

const imageVariants = {
  rest: { scale: 1 },
  hover: { scale: 1.05 },
};

const overlayVariants = {
  rest: { opacity: 0 },
  hover: { opacity: 1 },
};

const detailsVariants = {
  rest: { opacity: 0, y: 12 },
  hover: { opacity: 1, y: 0 },
};

/* ================= COMPONENT ================= */
export default function WorkSection() {
  return (
    <section
      id="work"
      className="relative py-32 overflow-hidden"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-[#0e202b]/90 z-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 space-y-24">

        {/* ================= HEADING ================= */}
        <div className="max-w-3xl space-y-6">
          <div className="inline-flex items-center gap-2 bg-white/10 px-6 py-2 rounded-full text-sm text-white w-fit">
            Selected Work
          </div>

          <h2 className="text-[3.5rem] font-bold leading-tight text-white">
            Moments from the mountains.
          </h2>

          <p className="text-lg text-gray-300">
            A curated selection of expeditions, landscapes, and stories captured
            across some of the world’s most remote and demanding terrain.
          </p>
        </div>

        {/* ================= PROJECT GRID ================= */}
        <div className="grid md:grid-cols-2 gap-10">
          {projects.map((project, i) => (
            <motion.div
              key={i}
              className="relative"
              variants={cardVariants}
              initial="rest"
              whileHover="hover"
              animate="rest"
              transition={{ duration: 0.35, ease: "easeOut" }}
            >
              <div className="relative rounded-[20px] shadow-[rgba(0,0,0,0.25)_0px_10px_30px]">

                {/* IMAGE */}
                <div className="relative overflow-hidden rounded-[17px]">
                  <motion.img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-[360px] object-cover"
                    variants={imageVariants}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    draggable={false}
                    loading="lazy"
                  />

                  {/* BLUR OVERLAY */}
                  <motion.div
                    className="absolute inset-0 backdrop-blur-[6px] bg-black/20"
                    variants={overlayVariants}
                    transition={{ duration: 0.4 }}
                  />
                </div>

                {/* DETAILS (ON HOVER) */}
                <motion.div
                  className="absolute bottom-4 left-4 right-4"
                  variants={detailsVariants}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                >
                  <div className="bg-gray-600/30 backdrop-blur rounded-[16px] p-5 flex items-center justify-between gap-4">
                    <div>
                      <h3 className="text-lg font-semibold text-white">
                        {project.title}
                      </h3>
                      <p className="text-sm text-gray-300">
                        {project.subtitle}
                      </p>
                    </div>

                    <div className="bg-gray-500/40 rounded-[10px] px-4 py-3 flex gap-1">
                      <span className="w-1 h-1 bg-[#f0f0f0] rounded-full" />
                      <span className="w-1 h-1 bg-[#f0f0f0] rounded-full" />
                    </div>
                  </div>
                </motion.div>

              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
